function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self1 = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self1, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { DeviceType } from '@sky-uk-ott/client-lib-js-device';
import { CoreVideoInternal } from '../../../core-video-internal';
import { TimedMetadataType } from '../../../core/player/player-engine-item';
import { PlayerState } from '../../../core/player/player-state';
import { AdInsertionStrategy, MediaContainer, PlaybackType, StreamingProtocol } from '../../../core/player/playout-data';
import { StaticAsset } from '../../../core/session-controller/asset';
import { sdkLogger } from '../../../logger';
import { checkIsManifestLinearType } from '../../../utils/playback-type';
import { Scte35Parser } from '../../../utils/scte35';
import { appendQueryParams, getOriginFromUrl } from '../../../utils/url-builder';
import { AdInsertionType } from '../../ad-insertion-type';
import { Vam } from '../../vac/vam/vam-addon';
import { AdBreakType, TrackingEventType } from '../common';
import { PixelFetch } from '../pixel-fetch';
import { InternalSessionState } from '../../../core/session-controller/session-controller.enums';
var SESSION_START_AD_INSERTION_SAFEGUARD = 1;
export var TimelineAdvertsAddon = /*#__PURE__*/ function() {
    "use strict";
    function TimelineAdvertsAddon(adBreakProvider, session, playbackType, pauseAdDispatcher, playoutData) {
        var pixelFetch = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : new PixelFetch(self), adBreaksFilter = arguments.length > 6 ? arguments[6] : void 0;
        _class_call_check(this, TimelineAdvertsAddon);
        var _this = this;
        _define_property(this, "adBreakProvider", void 0);
        _define_property(this, "session", void 0);
        _define_property(this, "playbackType", void 0);
        _define_property(this, "pauseAdDispatcher", void 0);
        _define_property(this, "playoutData", void 0);
        _define_property(this, "pixelFetch", void 0);
        _define_property(this, "adBreaksFilter", void 0);
        _define_property(this, "name", void 0);
        _define_property(this, "playoutOptions", void 0);
        _define_property(this, "advertising", void 0);
        _define_property(this, "unregisterSessionTimedMetadataReceivedObserver", void 0);
        _define_property(this, "liveBreakCounter", void 0);
        _define_property(this, "logger", void 0);
        _define_property(this, "processedMetadata", void 0);
        _define_property(this, "vacAddon", void 0);
        _define_property(this, "handleTimedMetadata", void 0);
        this.adBreakProvider = adBreakProvider;
        this.session = session;
        this.playbackType = playbackType;
        this.pauseAdDispatcher = pauseAdDispatcher;
        this.playoutData = playoutData;
        this.pixelFetch = pixelFetch;
        this.adBreaksFilter = adBreaksFilter;
        this.name = 'TimelineAdverts';
        this.playoutOptions = {
            adInsertionStrategy: AdInsertionStrategy.CSAI,
            isPlayerAdEventsRequired: false,
            isPlayerAdBreakDataRequired: false,
            isTimelineAdManagementRequired: true,
            adProvider: AdInsertionType.MultiPlayerCsai
        };
        this.logger = sdkLogger.withContext('TimelineAds');
        this.processedMetadata = {};
        this.handleTimedMetadata = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(metadata) {
                var scteScheme, scteParser, linearBreakStartTime, adData, eventKey, contentTimePosition, advertAssetGroups, e, message;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            scteScheme = 'urn:scte:scte35:2014:xml+bin';
                            if (!(metadata.type === TimedMetadataType.EventStream && metadata.schemeIdUri === scteScheme && checkIsManifestLinearType(_this.playbackType))) return [
                                3,
                                5
                            ];
                            if (!metadata.scte35Data) {
                                return [
                                    2
                                ];
                            }
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                4,
                                ,
                                5
                            ]);
                            scteParser = new Scte35Parser();
                            linearBreakStartTime = metadata.startTime;
                            adData = scteParser.parseAdDataFromScte35Base64(metadata.scte35Data);
                            if (!adData) return [
                                2
                            ];
                            // not an advert SCTE
                            eventKey = "break:".concat(linearBreakStartTime);
                            if (eventKey in _this.processedMetadata) return [
                                2
                            ];
                            _this.processedMetadata[eventKey] = true;
                            return [
                                4,
                                _this.session.waitForOneOfStates([
                                    InternalSessionState.Playing,
                                    InternalSessionState.Paused
                                ])
                            ];
                        case 2:
                            _state.sent();
                            contentTimePosition = _this.session.getContentTimePosition();
                            if (contentTimePosition && contentTimePosition - SESSION_START_AD_INSERTION_SAFEGUARD > linearBreakStartTime) {
                                _this.logger.info('Ignoring linear ad due to late session start');
                                return [
                                    2
                                ];
                            }
                            return [
                                4,
                                _this.getAdvertsForSession(_this.hydrateAdvertisingData(adData), linearBreakStartTime)
                            ];
                        case 3:
                            advertAssetGroups = _state.sent();
                            _this.session.notifyTimelineAssetsAvailable(advertAssetGroups);
                            return [
                                3,
                                5
                            ];
                        case 4:
                            e = _state.sent();
                            message = "Error when getting ads for linear Timeline CSAI: ".concat(e);
                            _this.logger.error(message);
                            _this.session.notifyWarning("SESSION.DUAL_PLAYER_ADS.LIVE_ADS_FAILED", message);
                            return [
                                3,
                                5
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(metadata) {
                return _ref.apply(this, arguments);
            };
        }();
        this.liveBreakCounter = 1;
        this.unregisterSessionTimedMetadataReceivedObserver = session.onTimedMetadataReceived(this.handleTimedMetadata);
    }
    _create_class(TimelineAdvertsAddon, [
        {
            key: "prepareAdvertising",
            value: function prepareAdvertising(requestOptions) {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        if (!_this.vacAddon) {
                            _this.logger.warn('Vac addon not initialised yet');
                            return [
                                2,
                                Promise.resolve(null)
                            ];
                        }
                        return [
                            2,
                            _this.vacAddon.fetchVacResponse(requestOptions)
                        ];
                    });
                })();
            }
        },
        {
            key: "advertisingData",
            get: function get() {
                return this.advertising;
            }
        },
        {
            key: "setAdvertising",
            value: function setAdvertising(advertising) {
                this.advertising = advertising;
            }
        },
        {
            key: "setVacAddon",
            value: function setVacAddon(vacAddon) {
                this.vacAddon = vacAddon;
            }
        },
        {
            key: "getAdvertsForSession",
            value: function getAdvertsForSession() {
                var advertising = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.advertising, linearBreakStartTime = arguments.length > 1 ? arguments[1] : void 0;
                var _this = this;
                return _async_to_generator(function() {
                    var adData, isEmpty, emptyPrerolls, unmappedFilteredAdBreaks, filteredAdBreaks, advertAssetGroups;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!('contentId' in advertising)) {
                                    return [
                                        2,
                                        []
                                    ];
                                }
                                return [
                                    4,
                                    _this.adBreakProvider.getAdBreaks(advertising)
                                ];
                            case 1:
                                adData = _state.sent();
                                _this.pauseAdDispatcher.addAdEventsFromAdData(adData.nonLinearAds);
                                isEmpty = function(adBreak) {
                                    return !adBreak.ads || adBreak.ads.length === 0;
                                };
                                emptyPrerolls = adData.adBreaks.filter(function(adBreak) {
                                    return adBreak.type === AdBreakType.Preroll && isEmpty(adBreak);
                                });
                                if (emptyPrerolls.length > 0) {
                                    _this.handleEmptyPrerolls(emptyPrerolls);
                                }
                                unmappedFilteredAdBreaks = _this.adBreaksFilter ? _this.adBreaksFilter(_this.session.getPrecursor().sessionItem, adData.adBreaks) : adData.adBreaks;
                                filteredAdBreaks = unmappedFilteredAdBreaks.map(function(adBreak) {
                                    if (linearBreakStartTime && adBreak.position === 0) {
                                        adBreak.position = linearBreakStartTime;
                                    }
                                    var expectedDuration = 0;
                                    adBreak.ads.forEach(function(ad) {
                                        if (CoreVideoInternal.deviceType === DeviceType.YouView && _this.playoutData) {
                                            // For more information please see https://github.com/sky-uk/core-video-team/issues/7043
                                            _this.logger.info('Appending yo.up into CDNs uri returned by Ad Breaks Provider');
                                            ad.cdns.map(function(cdn) {
                                                return _this.hydrateAdvertisingCdn(cdn);
                                            });
                                        }
                                        ad.adBreakId = adBreak.id;
                                        expectedDuration += ad.expectedDuration;
                                    });
                                    adBreak.expectedDuration = expectedDuration;
                                    return adBreak;
                                });
                                _this.session.notifyAdBreakDataReceived(filteredAdBreaks);
                                advertAssetGroups = filteredAdBreaks.map(function(adBreak) {
                                    var assetGroup = {
                                        assets: adBreak.ads.map(function(ad, index) {
                                            var adAsset = _this.createAsset(ad);
                                            // the first advert playing marks the start of the ad break
                                            if (index === 0) {
                                                adAsset.onStateChanged(function(state) {
                                                    if (state === PlayerState.Playing) {
                                                        _this.triggerTrackingEvent(adBreak, TrackingEventType.BreakStart);
                                                    }
                                                }, _this);
                                            }
                                            _this.listenToAdEvents(ad, adAsset);
                                            // the last advert finishing marks the end of the ad break
                                            if (index === adBreak.ads.length - 1) {
                                                adAsset.onStateChanged(function(state) {
                                                    if (state === PlayerState.Finished) {
                                                        _this.triggerTrackingEvent(adBreak, TrackingEventType.BreakEnd);
                                                    }
                                                }, _this);
                                            }
                                            return adAsset;
                                        }),
                                        position: adBreak.position,
                                        adBreak: adBreak
                                    };
                                    return assetGroup;
                                });
                                return [
                                    2,
                                    advertAssetGroups
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.unregisterSessionTimedMetadataReceivedObserver();
            }
        },
        {
            key: "handleEmptyPrerolls",
            value: function handleEmptyPrerolls(adBreaks) {
                var _this = this;
                adBreaks.forEach(function(adBreak) {
                    var _adBreak_trackingEvents;
                    (_adBreak_trackingEvents = adBreak.trackingEvents) === null || _adBreak_trackingEvents === void 0 ? void 0 : _adBreak_trackingEvents.forEach(function(event) {
                        if (!event.isActivated) {
                            _this.logger.verbose("Firing tracking event ".concat(event.url, " for empty preroll ad break ").concat(adBreak.id));
                            event.isActivated = true;
                            _this.pixelFetch.fetch(event.url);
                        }
                    });
                });
            }
        },
        {
            key: "hydrateAdvertisingCdn",
            value: function hydrateAdvertisingCdn(cdn) {
                var cdnEndpoint = getOriginFromUrl(this.playoutData.cdns[0].url);
                var queryParams = {
                    'yo.up': cdnEndpoint
                };
                cdn.url = appendQueryParams(cdn.url, queryParams, {
                    shouldNotEncodeURI: true
                });
                return cdn;
            }
        },
        {
            key: "createAsset",
            value: function createAsset(ad) {
                var _this_playoutData, _this_playoutData1;
                var _ad_cdns;
                var adPlayoutData = {
                    cdns: (_ad_cdns = ad.cdns) !== null && _ad_cdns !== void 0 ? _ad_cdns : [],
                    stream: {
                        protocol: ad.streamingProtocol
                    },
                    type: PlaybackType.Advert,
                    heartbeat: (_this_playoutData = this.playoutData) === null || _this_playoutData === void 0 ? void 0 : _this_playoutData.heartbeat,
                    prefetch: (_this_playoutData1 = this.playoutData) === null || _this_playoutData1 === void 0 ? void 0 : _this_playoutData1.prefetch
                };
                if (ad.streamingProtocol === StreamingProtocol.PDL) {
                    adPlayoutData.stream.container = MediaContainer.MP4;
                }
                return new StaticAsset(adPlayoutData);
            }
        },
        {
            key: "listenToAdEvents",
            value: function listenToAdEvents(ad, asset) {
                var _this = this;
                asset.onStateChanged(function(state) {
                    return _this.handleAdStateChanged(ad, state);
                }, this);
                asset.onPositionChanged(function(position) {
                    return _this.handleAdPositionChanged(ad, position);
                }, this);
                asset.onError(function(error) {
                    return _this.handleAdError(ad, error);
                }, this);
                asset.onSkipped(function() {
                    return _this.handleAdSkipped(ad);
                }, this);
            }
        },
        {
            key: "hydrateAdvertisingData",
            value: function hydrateAdvertisingData(adData) {
                var vac = this.advertising.vac;
                if (!vac) throw new Error('unavailable ads configuration');
                var hydratedVac = Vam.hydrateVamResponse(vac, adData.contentId, adData.duration, this.liveBreakCounter++);
                return _object_spread_props(_object_spread({}, this.advertising), {
                    vac: hydratedVac
                });
            }
        },
        {
            key: "handleAdPositionChanged",
            value: function handleAdPositionChanged(ad, position) {
                var quarterDuration = ad.expectedDuration / 4;
                if (position > quarterDuration * 3) {
                    this.triggerTrackingEvent(ad, TrackingEventType.ThirdQuartile);
                } else if (position > quarterDuration * 2) {
                    this.triggerTrackingEvent(ad, TrackingEventType.Midpoint);
                } else if (position > quarterDuration) {
                    this.triggerTrackingEvent(ad, TrackingEventType.FirstQuartile);
                }
            }
        },
        {
            key: "handleAdStateChanged",
            value: function handleAdStateChanged(ad, state) {
                if (state === PlayerState.Playing) {
                    this.triggerTrackingEvent(ad, TrackingEventType.AdImpression);
                } else if (state === PlayerState.Finished) {
                    this.triggerTrackingEvent(ad, TrackingEventType.AdFinished);
                }
            }
        },
        {
            key: "handleAdError",
            value: function handleAdError(ad, _error) {
                this.triggerTrackingEvent(ad, TrackingEventType.Error);
            }
        },
        {
            key: "handleAdSkipped",
            value: function handleAdSkipped(ad) {
                this.triggerTrackingEvent(ad, TrackingEventType.Skipped);
            }
        },
        {
            key: "triggerTrackingEvent",
            value: function triggerTrackingEvent(ad, eventType) {
                var _this = this;
                var _ad_trackingEvents;
                (_ad_trackingEvents = ad.trackingEvents) === null || _ad_trackingEvents === void 0 ? void 0 : _ad_trackingEvents.forEach(function(trackingEvent) {
                    if (trackingEvent.type === eventType && !trackingEvent.isActivated) {
                        trackingEvent.isActivated = true;
                        _this.pixelFetch.fetch(trackingEvent.url);
                    }
                });
            }
        }
    ]);
    return TimelineAdvertsAddon;
}();

//# sourceMappingURL=timeline-adverts-addon.js.map